<template>
<div class="chapter">
<div class="inner_page">
<p class="p1"><span class="t2">By</span> A<span class="t3">NNA</span> M<span class="t3">ARTIN</span></p>
<p class="p0"><span class="t4">N</span><span class="t5">OVELS</span></p>
<p class="p0"><span class="t2">Cricket</span></p>
<p class="p0"><span class="t2">Jurassic Heart</span></p>
<p class="p0"><span class="t2">Tattoos &amp; Teacups</span></p>
<p class="p2"><span class="t2">Another Way • Of Being Yours</span></p>
<p class="p0"><span class="t4">N</span><span class="t5">OVELLAS</span></p>
<p class="p0"><span class="t2">Kid Gloves</span></p>
<p class="p3"><span class="t2">Published by</span> <span class="t6">D</span><span class="t7">REAMSPINNER</span> <span class="t6">P</span><span class="t7">RESS</span></p>
<p class="p0"><span class="t2">http://www.dreamspinnerpress.com</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 002.vue?248bb284